import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpdateDocumentArchivesPayload, UpdateDocumentArchivesInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPDATE_DOCUMENT_IS_ABANDONED = gql`
    mutation updateDocumentArchiveIsAbandoned($input: UpdateDocumentArchivesInput!){
        updateDocumentArchiveIsAbandoned(input: $input){
            message
            errors {
                code
                message
            }
            result
        }
    }
`;

export const mutationUpdateDocumentArchiveIsAbandoned = async (
    client: ApolloClient<NormalizedCacheObject>,
    args: {
        inputData: UpdateDocumentArchivesInput
    }
): Promise<UpdateDocumentArchivesPayload | undefined> => {
    const { documentArchiveIds, noteHeader, note } = args.inputData;
    const { data, errors } = await client.mutate<{ updateDocumentArchiveIsAbandoned: UpdateDocumentArchivesPayload }>({
        variables: {
            input: {
                documentArchiveIds,
                noteHeader,
                note
            }
        },
        mutation: MUTATION_UPDATE_DOCUMENT_IS_ABANDONED
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the document archive(s) abandon and note save.');
    }
    if (data && data.updateDocumentArchiveIsAbandoned) {
        return data.updateDocumentArchiveIsAbandoned;
    }
    return undefined;
};